export enum OrderStatus {
	NEW_ORDER = 'new_order',
	SENT_TO_BANK = 'sent_to_bank',
	GOT_TO_BANK = 'got_to_bank',
	WORK = 'work',
	COMPLETED = 'completed',
	UNBLOCK_CHECKING = 'unblock_checking',
	UNBLOCK_CLARIFICATION = 'unblock_clarification',
	UNBLOCK_DECLINED = 'unblock_declined',
	REJECTED_BY_TIME = 'rejected_by_time',
	DRAFT = 'draft',
}

export enum OrderStatusTranslate {
	NEW_ORDER = 'Новая',
	SENT_TO_BANK = 'Отправлено в банк',
	GOT_TO_BANK = 'Доставлено в банк',
	WORK = 'В работе',
	COMPLETED = 'Завершено',
	UNBLOCK_CHECKING = 'На рассмотрении в ДС',
	UNBLOCK_CLARIFICATION = 'Возврат на доработку',
	UNBLOCK_DECLINED = 'Отклонена ДС',
	REJECTED_BY_TIME = 'Отклонен по сроку (31 день)',
	DRAFT = 'Черновик',
}

export const TurnOverStatus = {
	TURNOVER: 'выполнен',
	RBIDOS_YES: 'да',
	RBIDOS_NO: 'нет',
}

export enum OrderStatusesTypes {
	PAO_SBERBANK = 'sberbank',
	DZO = 'dzo',
	CRM_STATUSES = 'ckr',
	BANK_ACCOUNT = 'bankAccount',
}

export const OrderStatusesTypesTranslate = {
	[OrderStatusesTypes.PAO_SBERBANK]: 'ПАО Сбербанк',
	[OrderStatusesTypes.DZO]: 'Продукт ДЗО',
	[OrderStatusesTypes.CRM_STATUSES]: 'Статусы ЦКР',
	[OrderStatusesTypes.BANK_ACCOUNT]: 'Статусы рас. счетов',
}
